(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
document.addEventListener('submit', async function(event) {
  const form = event.target.closest('.js-ys-up-form');
  if (!form) return;
  event.preventDefault();

  const button = form.querySelector('.ys-up-add');
  const label = button ? button.querySelector('span') : null;
  const original = label ? label.textContent : '';

  if (button) {
    button.classList.add('is-loading');
    button.disabled = true;
  }
  if (label) label.textContent = 'Ajout...';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    });
    if (!response.ok) throw new Error('add_failed');

    if (button) button.classList.add('is-added');
    if (label) label.textContent = 'Ajouté ✓';

    window.setTimeout(function() {
      window.location.reload();
    }, 450);
  } catch (error) {
    if (button) {
      button.classList.remove('is-loading');
      button.disabled = false;
    }
    if (label) label.textContent = original || 'Ajouter';
    HTMLFormElement.prototype.submit.call(form);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
(function(){
  var root=document.getElementById('ys-search');
  if(!root)return;
  var searchParams=new URLSearchParams(window.location.search);
  var incoming=(searchParams.get('q')||'').trim().toLocaleLowerCase('fr');
  if(incoming==='sac isotherme'||incoming==='title:isotherme or product_type:isotherme'){
    searchParams.set('q','title:sac AND title:isotherme');
    window.location.replace(window.location.pathname+'?'+searchParams.toString());
    return;
  }
  var queryForm=root.querySelector('.ys-search-form');
  if(queryForm)queryForm.addEventListener('submit',function(){var input=queryForm.querySelector('[name="q"]');if(input&&input.value.trim().toLocaleLowerCase('fr')==='sac isotherme')input.value='title:sac AND title:isotherme'});
  var open=root.querySelector('[data-search-open]');
  var overlay=root.querySelector('[data-search-close]');
  var form=document.getElementById('ys-search-filter-form');
  var sort=document.getElementById('ys-search-sort');
  function openFilters(){root.classList.add('is-filters');document.documentElement.style.overflow='hidden'}
  function closeFilters(){root.classList.remove('is-filters');document.documentElement.style.overflow=''}
  if(open)open.addEventListener('click',openFilters);
  if(overlay)overlay.addEventListener('click',closeFilters);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeFilters()});
  if(form){
    var wide=window.matchMedia('(min-width:1025px)');
    var timer=null;
    form.addEventListener('change',function(e){
      if(!wide.matches)return;
      if(e.target.type==='number'){clearTimeout(timer);timer=setTimeout(function(){form.submit()},650)}
      else form.submit();
    });
  }
  if(sort&&form){
    sort.addEventListener('change',function(){
      var hidden=form.querySelector('[name="sort_by"]');
      if(hidden)hidden.value=sort.value;
      form.submit();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yosac-collection-seo"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  var button = event.target.closest('[data-ys-read-more]');
  if (!button) return;
  var section = button.closest('.ys-collection-seo');
  var text = section && section.querySelector('[data-ys-seo-text]');
  if (!text) return;
  var open = text.classList.toggle('is-open');
  button.setAttribute('aria-expanded', open ? 'true' : 'false');
  button.textContent = open ? 'Réduire' : (button.dataset.closedLabel || 'Lire la suite');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yosac-footer"] && !Shopify.designMode) return;
  try {
    
(function(){
  var media=window.matchMedia('(max-width:700px)');
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');

  function syncAccordions(){
    document.querySelectorAll('.ys-ftr-col').forEach(function(item){
      item.open=!media.matches;
    });
  }

  function initTrustCarousel(){
    document.querySelectorAll('[data-trust-carousel]').forEach(function(carousel){
      var track=carousel.querySelector('[data-trust-track]');
      var items=track ? Array.prototype.slice.call(track.querySelectorAll('.ys-ftr-t')) : [];
      var prev=carousel.querySelector('[data-trust-prev]');
      var next=carousel.querySelector('[data-trust-next]');
      var timer=null;
      var resumeTimer=null;
      var index=0;

      if(!track || items.length<2){return;}

      function nearestIndex(){
        var left=track.scrollLeft;
        var best=0;
        var distance=Infinity;
        items.forEach(function(item,i){
          var d=Math.abs(item.offsetLeft-track.offsetLeft-left);
          if(d<distance){distance=d;best=i;}
        });
        index=best;
      }

      function goTo(target,behavior){
        if(target<0){target=items.length-1;}
        if(target>=items.length){target=0;}
        index=target;
        track.scrollTo({left:items[index].offsetLeft-track.offsetLeft,behavior:behavior||'smooth'});
      }

      function stop(){
        if(timer){window.clearInterval(timer);timer=null;}
      }

      function start(){
        stop();
        if(media.matches && !reduced.matches){
          timer=window.setInterval(function(){goTo(index+1,'smooth');},3800);
        }
      }

      function pauseThenResume(){
        stop();
        if(resumeTimer){window.clearTimeout(resumeTimer);}
        resumeTimer=window.setTimeout(start,7000);
      }

      if(prev){prev.addEventListener('click',function(){nearestIndex();goTo(index-1,'smooth');pauseThenResume();});}
      if(next){next.addEventListener('click',function(){nearestIndex();goTo(index+1,'smooth');pauseThenResume();});}

      var scrollTimer=null;
      track.addEventListener('scroll',function(){
        if(scrollTimer){window.clearTimeout(scrollTimer);}
        scrollTimer=window.setTimeout(nearestIndex,120);
      },{passive:true});

      ['pointerdown','touchstart','wheel'].forEach(function(name){
        track.addEventListener(name,pauseThenResume,{passive:true});
      });

      carousel.addEventListener('mouseenter',stop);
      carousel.addEventListener('mouseleave',start);
      carousel.addEventListener('focusin',stop);
      carousel.addEventListener('focusout',start);

      function syncCarousel(){
        if(!media.matches){
          stop();
          track.scrollTo({left:0,behavior:'auto'});
          index=0;
        }else{
          nearestIndex();
          start();
        }
      }

      syncCarousel();
      if(media.addEventListener){media.addEventListener('change',syncCarousel);}else if(media.addListener){media.addListener(syncCarousel);}
      if(reduced.addEventListener){reduced.addEventListener('change',syncCarousel);}else if(reduced.addListener){reduced.addListener(syncCarousel);}
    });
  }

  syncAccordions();
  if(media.addEventListener){media.addEventListener('change',syncAccordions);}else if(media.addListener){media.addListener(syncAccordions);}

  document.querySelectorAll('.ys-ftr-col summary').forEach(function(summary){
    summary.addEventListener('click',function(event){
      if(!media.matches){event.preventDefault();}
    });
  });

  initTrustCarousel();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yosac-homepage"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.ys-homepage').forEach(function(root){
    var tabs=[].slice.call(root.querySelectorAll('.ys-tab'));
    var more=root.querySelector('.ys-more-link');
    function select(tab){
      var level=tab.getAttribute('data-level');
      tabs.forEach(function(t){var on=t===tab;t.setAttribute('aria-selected',on?'true':'false');t.tabIndex=on?0:-1;});
      root.querySelectorAll('[data-panel]').forEach(function(p){p.hidden=p.getAttribute('data-panel')!==level;});
      if(more){
        var key=level==='college'?'college':level==='lycee'?'lycee':'primary';
        more.href=more.getAttribute('data-'+key+'-href');
        more.textContent=more.getAttribute('data-'+key+'-text');
      }
    }
    tabs.forEach(function(t,i){
      t.addEventListener('click',function(){select(t);});
      t.addEventListener('keydown',function(e){var n=e.key==='ArrowRight'?1:e.key==='ArrowLeft'?-1:0;if(!n)return;e.preventDefault();var x=tabs[(i+n+tabs.length)%tabs.length];x.focus();select(x);});
    });
    var input=root.querySelector('.ys-weight-input'),out=root.querySelector('.ys-calc-result');
    if(input&&out){
      var min=parseFloat(input.min)||10,max=parseFloat(input.max)||120;
      var f=function(v){return v.toLocaleString('fr-FR',{maximumFractionDigits:1});};
      input.addEventListener('input',function(){
        var w=parseFloat(String(input.value).replace(',','.'));
        if(!w||w<min||w>max){out.innerHTML='Saisissez un poids entre '+min+' et '+max+'&nbsp;kg.';return;}
        out.innerHTML='Sac rempli conseillé&#8239;: <b>'+f(w*.10)+' à '+f(w*.15)+'&nbsp;kg</b> maximum.';
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yosac-reviews-page"] && !Shopify.designMode) return;
  try {
    
(function() {
  var root = document.getElementById('ys-rev');
  if (!root) return;

  var wall = root.querySelector('[data-review-wall]');
  var pagination = root.querySelector('[data-review-pagination]');
  var totalReviews = 9949;
  var perPage = 15;
  var publicStoreId = 'GMebw0qZYA';
  var endpoint = 'https://storefront-api.loox.io/storefront/v1/store/' + publicStoreId + '/product-reviews';
  var productMeta = {"cartable-a-bandouliere-scolaire-sweettote":{"title":"Cartable à Bandoulière Scolaire - SweetTote®","levels":["Collège","Lycée","Étudiant"]},"cartable-a-dos-pikarush":{"title":"Cartable à Dos - PikaRush®","levels":["Primaire"]},"cartable-a-dos-capybara-dodocappy":{"title":"Cartable à Dos Capybara - DodoCappy®","levels":["Primaire","Collège"]},"cartable-a-dos-etudiantes-uniglow":{"title":"Cartable à Dos Étudiantes - UniGlow®","levels":["Primaire"]},"cartable-a-dos-scolaire-classroll":{"title":"Cartable à Dos Scolaire - ClassRoll®","levels":["Primaire","Collège","Lycée"]},"sac-a-dos-cartable-snapchic":{"title":"Cartable Orthopédique  - SnapChic®","levels":["Maternelle"]},"cartable-horizontal-sealpack":{"title":"Cartable Orthopédique - SealPack®","levels":["Maternelle"]},"gourde-deau-600ml":{"title":"Gourde d'Eau 600ml Gratuite","levels":[]},"mini-sac-a-dos-pixipack":{"title":"Mini Sac à Dos - PixiPack®","levels":["Étudiant"]},"sac-a-bandouliere-en-tendance-decontracte-pour-lycee":{"title":"Sac à Bandoulière Décontracté - Trendix®","levels":["Collège","Lycée"]},"sac-a-bandouliere-etudiante-unitote":{"title":"Sac à Bandoulière Étudiante - UniTote®","levels":["Collège","Lycée","Étudiant"]},"sac-a-bandouliere-toile-canvasway":{"title":"Sac à Bandoulière Toile – CanvasWay®","levels":["Collège","Lycée","Étudiant"]},"sac-a-dos-easyvibe":{"title":"Sac à Dos - EasyVibe®","levels":["Collège","Lycée"]},"sac-a-dos-impermeable-avec-chaine-pour-adolescente":{"title":"Sac à Dos - RainChic®","levels":["Primaire","Collège","Lycée"]},"sac-a-dos-oreilles-de-lapin-stitchy":{"title":"Sac à Dos - Stitchy®","levels":["Primaire"]},"sac-a-dos-techcarry":{"title":"Sac à Dos - TechCarry®","levels":["Collège","Lycée","Étudiant"]},"sac-a-dos-2-pieces-stitchy":{"title":"Sac à Dos 2 Pièces - Stitchy®","levels":["Primaire"]},"sac-a-dos-3-en-1-leopard-coeur-luvspark":{"title":"Sac à Dos 3 en 1 - LuvSpark®","levels":["Primaire","Collège"]},"sac-a-dos-3-en-1-trisplash":{"title":"Sac à Dos 3 en 1 - TriSplash®","levels":["Primaire","Collège"]},"sac-a-dos-3-en-1-cartoon-multitoon":{"title":"Sac à Dos 3 en 1 Cartoon - MultiToon®","levels":["Primaire","Collège"]},"sac-a-dos-a-roulettes-rollpack":{"title":"Sac à Dos à Roulettes -  RollPack®","levels":["Primaire","Collège"]},"sac-a-dos-a-roulettes-rollease":{"title":"Sac à Dos à Roulettes - RollEase®","levels":["Primaire"]},"sac-a-dos-a-roulettes-rollipack":{"title":"Sac à Dos à Roulettes - RolliPack®","levels":["Primaire","Collège"]},"sac-a-dos-a-roulettes-dinosaure":{"title":"Sac à Dos à Roulettes Orthopédique - Dinosaure®","levels":["Primaire","Collège"]},"sac-a-dos-scolaire-et-ordinateur-antivol-pour-etudiants":{"title":"Sac à Dos Anti-Vol - SecuPack®","levels":["Collège","Lycée"]},"sac-a-dos-araignee-3d-spidy":{"title":"Sac à Dos Araignée 3D - Spidy®","levels":["Maternelle","Primaire","Collège"]},"sac-a-dos-arc-en-ciel-rainbowy":{"title":"Sac à Dos Arc-en-Ciel - Rainbowy®","levels":["Maternelle","Primaire"]},"sac-a-dos-astronaute-astroflash":{"title":"Sac à Dos Astronaute - AstroFlash®","levels":["Primaire","Collège"]},"sac-a-dos-astronaute-astroroll":{"title":"Sac à Dos Astronaute - AstroRoll®","levels":["Maternelle"]},"sac-a-dos-astronaute-spacevibe":{"title":"Sac à Dos Astronaute - SpaceVibe®","levels":["Primaire","Collège"]},"sac-a-dos-astronaute-scolaire-astrokid":{"title":"Sac à Dos Astronaute Scolaire - AstroKid®","levels":["Primaire"]},"sac-a-dos-capybara-kawaii-cappybag":{"title":"Sac à Dos Capybara Kawaii - CappyBag®","levels":["Primaire","Collège"]},"sac-a-dos-capybara-rose-bobacappy":{"title":"Sac à Dos Capybara Rose - BobaCappy®","levels":["Maternelle"]},"sac-a-dos-college-teenpack":{"title":"Sac à Dos Collège - TeenPack®","levels":["Collège","Lycée"]},"sac-a-dos-coreen-mochila-k-style":{"title":"Sac à Dos Coréen Mochila - K-Style®","levels":["Collège","Lycée","Étudiant"]},"sac-a-dos-decole-transparent-clearclass":{"title":"Sac à Dos d'École Transparent - ClearClass®","levels":["Primaire","Collège","Lycée"]},"sac-a-dos-de-dessin-anime-magictoon":{"title":"Sac à Dos de Dessin Animé - MagicToon®","levels":["Maternelle"]},"sac-a-dos-dessin-anime-cappytoon":{"title":"Sac à Dos Dessin Animé - CappyToon®","levels":["Primaire","Collège"]},"sac-a-dos-dinosaure-dinomini":{"title":"Sac à Dos Dinosaure - DinoMini®","levels":["Maternelle"]},"sac-a-dos-dinosaure-dinoroar":{"title":"Sac à Dos Dinosaure - DinoRoar®","levels":["Maternelle"]},"sac-a-dos-cartable-canvedy":{"title":"Sac à Dos en Toile - CanvEdy®","levels":["Collège","Lycée","Étudiant"]},"sac-a-dos-en-velours-velvetseal":{"title":"Sac à Dos en Velours- VelvetSeal®","levels":["Collège","Lycée","Étudiant"]},"sac-a-dos-ergonomique-ergoease":{"title":"Sac à Dos Ergonomique - ErgoEase®","levels":["Primaire","Collège"]},"sac-a-dos-ergonomique-multipoches-pour-etudiants-lycee":{"title":"Sac à Dos Ergonomique - StuFlex®","levels":["Primaire","Collège","Lycée"]},"sac-a-dos-etanche-dryshield":{"title":"Sac à Dos Étanche - DryShield®","levels":["Primaire","Collège"]},"sac-a-dos-etudiant-impermeable-aquapack":{"title":"Sac à dos Étudiant Imperméable - AquaPack®","levels":["Collège","Lycée"]},"sac-a-dos-etudiante-multifonctionnel-multiflex":{"title":"Sac à Dos Étudiante Multifonctionnel - MultiFlex®","levels":["Étudiant"]},"sac-a-dos-fille-prettybag":{"title":"Sac à Dos Fille - PrettyBag®","levels":["Primaire","Collège"]},"sac-a-dos-fille-chiclina":{"title":"Sac à Dos Fille – ChicLina®","levels":["Primaire","Collège","Lycée"]},"sac-a-dos-fleurs-bloompak":{"title":"Sac à Dos Fleurs - BloomPak®","levels":["Étudiant"]},"sac-a-dos-garcon-boldino":{"title":"Sac à Dos Garçon – Boldino®","levels":["Collège","Lycée"]},"sac-a-dos-grande-capacite-packpro":{"title":"Sac à Dos Grande Capacité - PackPro®","levels":["Primaire","Collège"]},"sac-a-dos-imprime-multipoches-joypak":{"title":"Sac à Dos Imprimé Orthopédique - JoyPak®","levels":["Primaire","Collège"]},"sac-a-dos-kawaii-peluche-kirabunny":{"title":"Sac à Dos Kawaii Peluche - KiraBunny®","levels":["Primaire","Collège"]},"sac-a-dos-lapin-3d-bunnyhug":{"title":"Sac à Dos Lapin 3D - BunnyHug®","levels":["Maternelle"]},"sac-a-dos-lapin-3d-hoppabag":{"title":"Sac à Dos Lapin 3D - HoppaBag®","levels":["Primaire","Collège"]},"sac-a-dos-college-leger-en-tendance-pour-adolescent":{"title":"Sac à Dos Léger - LiteBoy®","levels":["Primaire","Collège","Lycée"]},"sac-a-dos-lumineux-lumobag":{"title":"Sac à Dos Lumineux - LumoBag®","levels":["Primaire","Collège"]},"sac-a-dos-matelasse-elegant-quiltychic":{"title":"Sac à Dos Matelassé Élégant - QuiltyChic®","levels":["Primaire","Collège","Lycée","Étudiant"]},"sac-a-dos-enfants-maternelle-mignon":{"title":"Sac à Dos Maternelle - Mignon®","levels":["Maternelle"]},"sac-a-dos-maternelle-minijoy":{"title":"Sac à Dos Maternelle - MiniJoy®","levels":["Maternelle"]},"sac-a-dos-maternelle-stitchy":{"title":"Sac à Dos Maternelle - Stitchy®","levels":["Maternelle"]},"sac-a-dos-maternelle-animaux-zoomini":{"title":"Sac à Dos Maternelle Animaux - ZooMini®","levels":["Maternelle"]},"sac-a-dos-mickey-mouse-mickeyzip":{"title":"Sac à Dos Mickey Mouse - MickeyZip®","levels":["Maternelle"]},"sac-a-dos-minimaliste-etudiante-rosylite":{"title":"Sac à Dos Minimaliste Étudiante - RosyLite®","levels":["Étudiant"]},"sac-a-dos-astronaute-astroshield":{"title":"Sac à Dos Orthopédique - AstroShield®","levels":["Primaire","Collège"]},"sac-a-dos-orthopedique-dinospin":{"title":"Sac à Dos Orthopédique - DinoSpin®","levels":["Primaire","Collège"]},"sac-a-dos-decontracte-durapack":{"title":"Sac à Dos Orthopédique - DuraPack®","levels":["Primaire"]},"sac-a-dos-etudiante-edupack":{"title":"Sac À Dos Orthopédique - EduPack®","levels":["Collège"]},"sac-a-dos-orthopedique-flexside":{"title":"Sac à Dos Orthopédique - FlexSide®","levels":["Primaire","Collège"]},"cartable-reflechissant-glowpack":{"title":"Sac à Dos Orthopédique - GlowPack®","levels":["Primaire"]},"sac-a-dos-etanche-a-plusieurs-compartiments-pour-college":{"title":"Sac à Dos Orthopédique - HyPakio®","levels":["Primaire","Collège","Lycée"]},"sac-a-dos-cp-orthopedique-et-lumineux-pour-garcon":{"title":"Sac à Dos Orthopédique - LumPack®","levels":["Primaire"]},"sac-a-dos-avec-port-usb-en-tendance-pour-ecole":{"title":"Sac à Dos Orthopédique - Luvaze®","levels":["Primaire","Collège","Lycée"]},"sac-a-dos-impermeable-mistyset":{"title":"Sac à Dos Orthopédique - MistySet®","levels":["Primaire"]},"sac-a-dos-tendance-modamist":{"title":"Sac à Dos Orthopédique - ModaMist®","levels":["Primaire","Collège"]},"sac-a-dos-a-motif-etoiles-skyshield":{"title":"Sac à Dos Orthopédique - SkyShield®","levels":["Primaire","Collège"]},"sac-a-dos-orthopedique-spineguard":{"title":"Sac à Dos Orthopédique - SpineGuard®","levels":["Primaire","Collège","Lycée"]},"sac-a-dos-orthopedique-spinesafe":{"title":"Sac à Dos Orthopédique - SpineSafe®","levels":["Primaire","Collège"]},"sac-a-dos-impermeable-toondry":{"title":"Sac à Dos Orthopédique - ToonDry®","levels":["Primaire","Collège"]},"sac-a-dos-cartable-trendruck":{"title":"Sac à Dos Orthopédique - TrendRuck®","levels":["Primaire"]},"sac-a-dos-tendance-trendset":{"title":"Sac à Dos Orthopédique - TrendSet®","levels":["Primaire","Collège","Lycée"]},"sac-a-dos-pour-ordinateur-impermeable-pour-adolescents":{"title":"Sac à Dos Orthopédique - WetTech®","levels":["Collège","Lycée"]},"sac-a-dos-scolaire-resistant-a-leau-pour-college":{"title":"Sac à Dos Orthopédique - Zypack®","levels":["Primaire","Collège","Lycée"]},"sac-a-dos-3-en-1-modamist":{"title":"Sac à Dos Orthopédique 3 en 1 - ModaMist®","levels":["Primaire","Collège","Lycée"]},"sac-a-dos-orthopedique-ergoback":{"title":"Sac à Dos Orthopédique – ErgoBack®","levels":["Primaire","Collège","Lycée","Étudiant"]},"sac-a-dos-ours-cartoon-bearacute":{"title":"Sac à Dos Ours Cartoon - BearaCute®","levels":["Primaire"]},"sac-a-dos-paw-patrol-pawhero":{"title":"Sac à Dos Paw Patrol - PawHero®","levels":["Maternelle"]},"sac-a-dos-peluche-mignon":{"title":"Sac à Dos Peluche - Mignon®","levels":["Maternelle"]},"sac-a-dos-pour-ecole-edusmart":{"title":"Sac à Dos pour École - EduSmart®","levels":["Primaire"]},"sac-a-dos-pour-lyceen-classpeak":{"title":"Sac à Dos pour Lycéen – ClassPeak®","levels":["Primaire","Collège","Lycée","Étudiant"]},"sac-a-dos-retro-retrovibe":{"title":"Sac à Dos Rétro - RetroVibe®","levels":["Étudiant"]},"sac-a-dos-scolaire-darkmode":{"title":"Sac à Dos Scolaire - DarkMode®","levels":["Primaire","Collège","Lycée"]},"sac-a-dos-scolaire-schooly":{"title":"Sac à Dos Scolaire - Schooly®","levels":["Primaire"]},"sac-a-dos-etudiants-pour-ordinateur-portable":{"title":"Sac à Dos Scolaire - StudyTech®","levels":["Collège","Lycée"]},"sac-a-dos-scolaire-fille-bellapack":{"title":"Sac à Dos Scolaire Fille - BellaPack®","levels":["Primaire","Collège","Lycée"]},"sac-a-dos-scolaire-garcon-steelrex":{"title":"Sac à Dos Scolaire Garçon - SteelRex®","levels":["Maternelle","Primaire"]},"sac-a-dos-scolaire-unisexe-neoclass":{"title":"Sac à Dos Scolaire Unisexe - NeoClass®","levels":["Collège","Lycée","Étudiant"]},"sac-a-dos-spider-man-spideyzip":{"title":"Sac à Dos Spider-Man - SpideyZip®","levels":["Maternelle"]},"sac-a-dos-tendance-pour-etudiante":{"title":"Sac à Dos Tendance - ChicStudy®","levels":["Collège","Lycée","Étudiant"]},"sac-a-dos-tendance-modapack":{"title":"Sac à Dos Tendance - ModaPack®","levels":["Primaire","Collège","Lycée"]},"sac-decole-maternelle-herokid":{"title":"Sac d'École Maternelle - HeroKid®","levels":["Maternelle"]},"sac-isotherme-enfant":{"title":"Sac Isotherme Enfant","levels":[]},"trousse-college-2-compartiments-flexorganiz":{"title":"Trousse Collège 2 Compartiments - FlexOrganiz®","levels":["Primaire","Collège"]},"trousse-double-compartiment-capybara-cappyzip":{"title":"Trousse Double Compartiment Capybara - CappyZip®","levels":["Primaire","Collège","Lycée"]},"trousse-fournitures-scolaires-2-compartiments":{"title":"Trousse Fournitures Scolaires - DualKit®","levels":["Primaire","Collège","Lycée"]},"trousse-scolaire-avec-verrouillage-safecase":{"title":"Trousse Scolaire avec Verrouillage – SafeCase®","levels":["Primaire","Collège"]},"trousse-scolaire-grande-capacite-maxistudy":{"title":"Trousse Scolaire Grande Capacité - MaxiStudy®","levels":["Primaire","Collège"]},"trousse-scolaire-licorne-3d-unidream":{"title":"Trousse Scolaire Licorne 3D - UniDream®","levels":["Maternelle","Primaire","Collège"]},"trousse-scolaire-pikachu-pikacase":{"title":"Trousse Scolaire Pikachu - PikaCase®","levels":["Primaire","Collège"]}};
  var fallbackCards = wall ? Array.prototype.slice.call(wall.querySelectorAll('.ys-review')) : [];
  var apiActive = false;
  var currentPage = 1;
  var totalPages = Math.ceil(totalReviews / perPage);
  var pageOneFirstId = null;

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function(ch) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[ch];
    });
  }

  function words(text) {
    return String(text || '').trim().split(/\s+/).filter(Boolean);
  }

  function initials(name) {
    var parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    return ((parts[0] || '').charAt(0) + (parts[parts.length - 1] || '').charAt(0)).toUpperCase();
  }

  function formatDate(value) {
    if (!value) return '';
    var d = new Date(value);
    if (isNaN(d.getTime())) return '';
    return new Intl.DateTimeFormat('fr-FR',{day:'2-digit',month:'2-digit',year:'numeric'}).format(d);
  }

  function pick(obj, paths) {
    for (var i=0;i<paths.length;i++) {
      var cur=obj, parts=paths[i].split('.');
      for (var j=0;j<parts.length && cur!=null;j++) cur=cur[parts[j]];
      if (cur !== undefined && cur !== null) return cur;
    }
    return null;
  }

  function findReviews(data) {
    var candidates=[
      pick(data,['reviews']),
      pick(data,['data']),
      pick(data,['items']),
      pick(data,['results']),
      pick(data,['productReviews']),
      pick(data,['data.reviews']),
      pick(data,['data.items']),
      pick(data,['data.results'])
    ];
    for(var i=0;i<candidates.length;i++){
      if(Array.isArray(candidates[i]) && candidates[i].length && typeof candidates[i][0] === 'object') return candidates[i];
    }
    return [];
  }

  function reviewId(r) {
    return String(pick(r,['id','reviewId','_id']) || '');
  }

  function normalizeReview(r) {
    var product = pick(r,['product']) || {};
    var handle = pick(r,['product.handle','productHandle','handle']) || '';
    var name = pick(r,['product.name','product.title','productName','productTitle']) || (productMeta[handle] && productMeta[handle].title) || '';
    return {
      id: reviewId(r),
      rating: Number(pick(r,['rating','score','stars']) || 0),
      text: String(pick(r,['review','text','body','content']) || ''),
      author: String(pick(r,['author','reviewerName','reviewer.name','name']) || 'Client'),
      verified: Boolean(pick(r,['verified','verifiedPurchase','isVerified'])),
      handle: String(handle),
      productName: String(name),
      levels: productMeta[handle] ? productMeta[handle].levels : []
    };
  }

  function renderStars(rating) {
    var html='';
    for(var i=1;i<=5;i++){
      html+='<svg class="'+(i>rating?'is-empty':'')+'" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.8l2.8 5.8 6.4.9-4.6 4.5 1.1 6.3L12 17.3l-5.7 3 1.1-6.3-4.6-4.5 6.4-.9z"/></svg>';
    }
    return html;
  }

  function renderReview(r) {
    var wrds=words(r.text), short=wrds.slice(0,30).join(' '), long=wrds.length>30;
    var model=(r.productName || '').split(' - ').pop();
    var meta='';
    (r.levels || []).forEach(function(level){meta+='<span>'+esc(level)+'</span>';});
    if(r.handle) meta+='<a href="/products/'+encodeURIComponent(r.handle)+'">'+esc(model)+'</a>';
    return '<article class="ys-review" data-review-id="'+esc(r.id)+'">'+
      '<div class="ys-rtop"><span class="ys-stars" role="img" aria-label="'+esc(r.rating)+' étoiles sur 5">'+renderStars(r.rating)+'</span>'+
      '<span class="ys-kind">'+(r.verified?'Achat vérifié':'Avis produit')+'</span></div>'+
      '<blockquote><span class="ys-review-short">« '+esc(short)+(long?'…':'')+' »</span>'+
      (long?'<span class="ys-review-full" hidden>« '+esc(r.text)+' »</span><button type="button" class="ys-readmore" data-review-toggle aria-expanded="false">Lire +</button>':'')+
      '</blockquote><div class="ys-rmeta">'+meta+'</div>'+
      '<div class="ys-who"><span class="ys-avatar" aria-hidden="true">'+esc(initials(r.author))+'</span><span>'+esc(r.author)+'</span></div></article>';
  }

  function scrollToReviews() {
    var heading=document.getElementById('ys-all-t');
    if(!heading) return;
    var top=heading.getBoundingClientRect().top+window.pageYOffset-110;
    window.scrollTo({top:top,behavior:'smooth'});
  }

  function renderPager(page) {
    if(!pagination) return;
    pagination.innerHTML='';
    if(totalPages<=1) return;
    function add(label,target,current,aria){
      var b=document.createElement('button');
      b.type='button'; b.className='ys-page'+(current?' is-current':'')+(aria?' ys-page--nav':'');
      b.textContent=label;
      if(current)b.setAttribute('aria-current','page');
      if(aria)b.setAttribute('aria-label',aria);
      b.addEventListener('click',function(){if(target!==currentPage){loadPage(target,true);}});
      pagination.appendChild(b);
    }
    if(page>1)add('‹',page-1,false,'Page précédente');
    var nums=[1,page-2,page-1,page,page+1,page+2,totalPages].filter(function(v,i,a){return v>=1&&v<=totalPages&&a.indexOf(v)===i;}).sort(function(a,b){return a-b;});
    var last=0;
    nums.forEach(function(n){
      if(last && n-last>1){var gap=document.createElement('span');gap.className='ys-page ys-page--gap';gap.textContent='…';pagination.appendChild(gap);}
      add(String(n),n,n===page,'');
      last=n;
    });
    if(page<totalPages)add('›',page+1,false,'Page suivante');
  }

  function renderFallbackPage(page, doScroll) {
    apiActive=false;
    currentPage=Math.max(1,Math.min(page,Math.max(1,Math.ceil(fallbackCards.length/perPage))));
    fallbackCards.forEach(function(card,index){
      card.hidden=index<(currentPage-1)*perPage||index>=currentPage*perPage;
    });
    totalPages=Math.max(1,Math.ceil(fallbackCards.length/perPage));
    renderPager(currentPage);
    if(apiNote){
      apiNote.hidden=false;
      apiNote.textContent='Aperçu limité aux avis récents synchronisés dans Shopify. Le flux Loox complet sera utilisé dès que l’API Storefront est disponible sur ce domaine.';
    }
    if(doScroll)scrollToReviews();
  }

  async function requestPage(page, mode) {
    var url=new URL(endpoint);
    url.searchParams.set('limit',String(perPage));
    if(mode==='offset') url.searchParams.set('offset',String((page-1)*perPage));
    else url.searchParams.set('page',String(page));
    var res=await fetch(url.toString(),{credentials:'omit',mode:'cors'});
    if(!res.ok) throw new Error('HTTP '+res.status);
    return await res.json();
  }

  async function loadPage(page, doScroll) {
    if(!wall) return;
    currentPage=Math.max(1,page);
    try{
      var data=await requestPage(currentPage,'page');
      var list=findReviews(data);
      if(!list.length) throw new Error('No reviews returned');
      if(currentPage===1) pageOneFirstId=reviewId(list[0]);
      if(currentPage>1 && pageOneFirstId && reviewId(list[0])===pageOneFirstId){
        data=await requestPage(currentPage,'offset');
        list=findReviews(data);
      }
      if(!list.length) throw new Error('No reviews returned');
      var normalized=list.slice(0,perPage).map(normalizeReview);
      wall.innerHTML=normalized.map(renderReview).join('');
      apiActive=true;
      var apiTotal=Number(pick(data,['total','meta.total','pagination.total','data.total','data.pagination.total']))||totalReviews;
      totalPages=Math.max(1,Math.ceil(apiTotal/perPage));
      renderPager(currentPage);
      if(doScroll)scrollToReviews();
    }catch(err){
      renderFallbackPage(Math.min(currentPage,Math.max(1,Math.ceil(fallbackCards.length/perPage))),doScroll);
    }
  }

  root.addEventListener('click',function(event){
    var button=event.target.closest('[data-review-toggle]');
    if(!button)return;
    var card=button.closest('.ys-review');
    if(!card)return;
    var shortText=card.querySelector('.ys-review-short');
    var fullText=card.querySelector('.ys-review-full');
    if(!shortText||!fullText)return;
    var expanded=button.getAttribute('aria-expanded')==='true';
    shortText.hidden=!expanded; fullText.hidden=expanded;
    button.setAttribute('aria-expanded',expanded?'false':'true');
    button.textContent=expanded?'Lire +':'Réduire';
  });

  if(wall){
    renderFallbackPage(1,false);
    loadPage(1,false);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
